<template>
  <div class="locked">
    <div class="locked-header">
      <h1 class="locked-header-text">{{ title }}</h1>
      <div class="locked-byline">{{ description }}</div>
    </div>
    <h1 class="locked-sub-header-text">{{ secondaryTitle }}</h1>
    <bg-icon class="info-icon" name="muscleBrain" v-if="showIcon" />
    <div class="add-holder">
      <div :key="item" v-for="item in infoItems" class="add-item">
        <bg-icon class="add-icon" name="add" />
        {{ item }}
      </div>
    </div>
    <div v-if="price" class="locked__price">Price: {{ price }}</div>
    <bg-button
      class="bottom-btn"
      text="Get This Addon Now!"
      @click="openHelpCrunch"
    />
  </div>
</template>

<style scoped>
.locked-header-text {
  font-size: 40px;
  font-weight: 800;
  margin-bottom: 10px;
}
.locked-sub-header-text {
  font-size: 30px;
  font-weight: 800;
  margin-bottom: 10px;
}
.bottom-btn {
  margin-bottom: 300px;
}
.info-icon {
  height: 140px;
  width: 140px;
}
.locked-byline {
  font-size: 18px;
  margin-bottom: 40px;
}
.info-holder {
  display: flex;
}
.add-item {
  font-size: 20px;
  padding-bottom: 20px;
  display: flex;
}
.add-icon {
  height: 20px;
  width: 20px;
  margin-right: 10px;
}
.locked__price {
  margin: 30px 0px;
  font-size: 21px;
}
</style>

<script>
import BgButton from "@/components/bg-button";
import BgIcon from "@/components/bg-icon";
import BgLogo from "@/components/bg-logo";

import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "locked",
  components: {
    BgButton,
    BgLogo,
    BgIcon,
  },
  computed: {
    ...mapState({
      testState: (state) => state.test,
    }),
  },
  props: {
    title: String,
    description: String,
    secondaryTitle: String,
    infoItems: Array,
    price: String,
    showIcon: {
      type: Boolean,
      default: true,
    },
    addonName: String,
  },
  methods: {
    openHelpCrunch() {
      HelpCrunch("openChat");
      HelpCrunch(
        "typeUserMessage",
        `Hello!  I would like to ask about extending the results of the test ${this.testState.name} from ${this.testState.company.name} with the ${this.addonName}!`
      );
    },
  },
};
</script>
